export enum GroupSortModeType {
  Natural = 'natural',
  ValueAsc = 'valueAsc',
  ValueDesc = 'valueDesc',
  CountAsc = 'countAsc',
  CountDesc = 'countDesc',
}
